module.exports = __webpack_public_path__ + "static/media/cross-red-thick.6ea84847.svg";